import api from "../axios.js";

const state = () => ({
  student: null,
  etag: null,
});

const getters = {
  getStudent: (state) => state.student,
};

const mutations = {
  setStudent(state, student) {
    state.student = student;
  },
  setETag(state, etag) {
    state.etag = etag;
  },
};

const actions = {
  // Hämta studentdata
  async fetchStudent({ commit, state, rootState }) {
    try {
      const headers = {
        Authorization: `Bearer ${rootState.token}`,
      };

      if (state.etag) {
        headers["If-None-Match"] = state.etag;
      }

      const res = await api.get(
        `${process.env.VUE_APP_API_BASE_URL}/students/me`,
        {
          headers,
          validateStatus: (status) => status === 200 || status === 304,
        }
      );

      if (res.status === 200) {
        commit("setStudent", res.data);

        const newETag = res.headers.etag;
        if (newETag) commit("setETag", newETag);

        // Returnera student för användning i add/remove interest
        return res.data;
      } else if (res.status === 304) {
        // Ingen ändring, returnera befintlig state
        return state.student;
      }
    } catch (err) {
      console.error("Fel vid hämtning av student:", err);
      throw err;
    }
  },

  // Uppdatera studentinfo
  async updateStudent({ commit, rootState }, formData) {
    try {
      const res = await api.put(
        `${process.env.VUE_APP_API_BASE_URL}/students/me`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${rootState.token}`,
          },
        }
      );

      commit("setStudent", res.data);

      const newETag = res.headers.etag;
      if (newETag) commit("setETag", newETag);

      // Returnera student för eventuell vidare användning
      return res.data;
    } catch (err) {
      console.error("Misslyckades att uppdatera student:", err);
      throw err;
    }
  },

  // Lägg till intresserat företag
  async addInterest({ commit, dispatch, rootState }, companyId) {
    try {
      await api.post(
        `${process.env.VUE_APP_API_BASE_URL}/students/me/interested`,
        { companyId },
        {
          headers: { Authorization: `Bearer ${rootState.token}` },
        }
      );

      // Hämta uppdaterad student
      const updatedStudent = await dispatch("fetchStudent");

      // Uppdatera root user
      commit("setUser", updatedStudent, { root: true });
    } catch (err) {
      console.error("Fel vid tillägg av intresse:", err);
      throw err;
    }
  },

  // Ta bort intresserat företag
  async removeInterest({ commit, dispatch, rootState }, companyId) {
    try {
      await api.delete(
        `${process.env.VUE_APP_API_BASE_URL}/students/me/interested`,
        {
          headers: { Authorization: `Bearer ${rootState.token}` },
          data: { companyId },
        }
      );

      // Hämta uppdaterad student
      const updatedStudent = await dispatch("fetchStudent");

      // Uppdatera root user
      commit("setUser", updatedStudent, { root: true });
    } catch (err) {
      console.error("Fel vid borttagning av intresse:", err);
      throw err;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
